<template>
  <div class="app-shell">
    <NavCabecera
      :class="[navClasses]"
      v-if="$store.state.showNavbar"
    />

    <sidenav
      class="mt-2"
      :custom_class="this.$store.state.mcolor"
      :class="[this.$store.state.isRTL ? 'fixed-end' : 'fixed-start']"
      v-if="$store.state.showSidenav"
    />

    <main
      class="main-content position-relative"
      :style="this.$store.state.isRTL ? 'overflow-x: hidden' : ''"
    >
      <router-view />
      

    </main>
    <CookieBanner />
    <app-footer />

    <AppToast />

    <!-- Modal login global -->
    <Modal :modalActive="$store.state.showLoginModal" @cerrar-modal="$store.commit('cerrarLoginModal')">
      <InicioSesionForm
        :esVisible="$store.state.showLoginModal"
        :redireccionar="false"
        @login-exitoso="onLoginExitoso"
        @cerrar-modal="$store.commit('cerrarLoginModal')"
      />
    </Modal>
  </div>
</template>

<script>
import Sidenav from "./examples/Sidenav";
import NavCabecera from "@/views/components/NavCabecera.vue";
import AppFooter from "@/examples/Footer.vue";
import CookieBanner from "@/components/CookieBanner.vue";
import Modal from "@/views/components/Modal.vue";
import InicioSesionForm from "@/views/components/InicioSesionForm.vue";
import AppToast from "@/components/AppToast.vue";
import "@fortawesome/fontawesome-free/css/all.css";
import { mapMutations } from "vuex";

export default {
  name: "App",
  components: { Sidenav, NavCabecera, AppFooter, CookieBanner, Modal, InicioSesionForm, AppToast },
  computed: {
    navClasses() {
      return "";
    },
  },
  async created() {
    try {
      const apiBase = process.env.VUE_APP_API_BASE_URL || '';
      const res  = await fetch(`${apiBase}/api/v2/public/app-config`);
      const cfg  = await res.json();
      if (cfg.gtm_id)                  this.initGTM(cfg.gtm_id);
      else if (cfg.ga4_id)             this.initGA4(cfg.ga4_id);
      if (cfg.ga4_id)                  window._quanty_ga4_id = cfg.ga4_id;
      if (cfg.meta_pixel_id)           this.initMetaPixel(cfg.meta_pixel_id);
    } catch (e) { /* sin config pública, no cargamos tracking */ }
  },
  methods: {
    ...mapMutations(["toggleConfigurator", "navbarMinimize"]),
    onLoginExitoso(email) {
      this.$store.commit("setEmailLogueado", email || '');
      this.$store.commit("cerrarLoginModal");
    },
    initGTM(id) {
      window.dataLayer = window.dataLayer || [];
      (function(w,d,s,l,i){
        w[l]=w[l]||[];
        w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});
        var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
        j.async=true; j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
        f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer',id);
    },
    initGA4(id) {
      // GA4 directo (sin GTM): carga gtag.js y configura el measurement ID
      const s = document.createElement('script');
      s.async = true;
      s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
      document.head.appendChild(s);
      window.dataLayer = window.dataLayer || [];
      window.gtag = function() { window.dataLayer.push(arguments); };
      window.gtag('js', new Date());
      window.gtag('config', id, { send_page_view: false }); // page_view lo manda el router
    },
    initMetaPixel(id) {
      if (window.fbq) return;
      /* eslint-disable */
      !function(f,b,e,v,n,t,s){
        if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s);
      }(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
      /* eslint-enable */
      window.fbq('consent', 'revoke'); // esperamos consentimiento RGPD
      window.fbq('init', id);
      window.fbq('track', 'PageView');
    },
  },
  beforeMount() {
    this.$store.state.isTransparent = "bg-transparent";
  },
};
</script>

<style>
/* Base layout: evita layouts “aplastados” */
html, body, #app {
  height: 100%;
}

/* Wrapper en columna para que el footer quede abajo y el contenido crezca */
.app-shell {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* Main: ocupa el espacio y deja aire al footer */
.main-content {
  flex: 1 1 auto;
  min-height: 0;
  padding-bottom: 120px; /* evita que el footer pise el contenido */
}

/* Si algún CSS externo bloquea el scroll del body, no nos fastidia la vida */
body {
  overflow-x: hidden;
  overflow-y: auto;
}
</style>
